export var STEPS;
(function (STEPS) {
    STEPS["ONE_CHOOSE_CLASS"] = "ONE_CHOOSE_CLASS";
    STEPS["TWO_CHOOSE_BODY_TYPE"] = "TWO_CHOOSE_BODY_TYPE";
    STEPS["THREE_CHOOSE_MOTORIZATION"] = "THREE_CHOOSE_MOTORIZATION";
})(STEPS || (STEPS = {}));
export const BPM_TAX = 'BPM';
export const GROSS_LIST_PRICE = 'grossListPrice';
